<template>
  <div>
    {{ translate.result.partner.received }}
    <br />
    {{ translate.result.partner.instruction }}

    <div class="manual-card-wrapper">
      <distributor-card
        v-for="(item, index) in resellers"
        :key="index"
        :info="item"
      />
    </div>

    {{ translate.result.partner.expectation }}
    <br />
    {{ translate.result.partner.whatsapp }}
    <br />
    <br />
    {{ translate.result.partner.thanks }}
  </div>
</template>

<script>
import DistributorCard from '../card/DistributorCard.vue';
export default {
  name: 'partner-result',
  props: {
    resellers: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DistributorCard,
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>

<style lang="css" scoped>
.manual-card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
</style>
